module.exports = __webpack_public_path__ + "static/media/a2.6b4997a0.jpg";